module.exports = {
  "country": "UA",
  "artist": "Zlata Ohnjewitsch",
  "song": "Gravity ",
  "year": "2013",
  "place": "3",
  "spotify": "0d3CHhMj2veGNsFJ8bpeT2"
};